import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

// 创建状态存储
const useUserStore = create(
  persist(
    (set) => ({
      userInfo: {
        cartNum: null, // 购物车数量
        complaintName: '',
        complaintPhone: '',
        couponNum: null, // 优惠券数量
        customerCode: '', // 客户编码
        customerLogin: 0, // 是否登录
        customerStarLevel: null, // plus会员
        encryptSwitch: '',
        messageNum: null,
        privateKey: '',
        publicKey: '',
        saleQQ: null,
        salesmanCode: '',
        salesmanName: '',
        salesmanPhone: '',
        isUserLogin: null, // 用户登录标识
        isSettleAccount: null, // 是否月结账户
        isShowAgentPayOrderList: null, // 是否显示代付订单列表
        needChooseCusType: null, // 是否需要确认账号类型
        existSendOrder: null, // 是否存在已发货订单
      },
      fromZone: '',
      plusInfo: {}, // plus信息
      projectConfigVO: {}, // 项目url
      updateProjectConfigVO: (projectConfigVO) => {
        set({ projectConfigVO });
      },
      commonConfigVO: {}, // 公共配置
      updateCommonConfigVO: (commonConfigVO) => {
        set({ commonConfigVO });
      },
      updateFromZone: (fromZone) => set({ fromZone }),
      //更新整个对象
      updateUserInfo: (userInfo) => set({ userInfo }), //合并userInfo
      //更新整个对象
      updatePlusInfo: (plusInfo) => set({ plusInfo }), //合并userInfo
    }),
    {
      name: 'user-sessionStorage',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default useUserStore;
